import {Component, OnInit} from '@angular/core';
import {RouteTrackerService} from '@mpt-fo/common/core/services/route-tracker.service';
import {Router} from '@angular/router';

@Component({
	selector: 'app-no-internet-connection',
	templateUrl: './no-internet-connection.component.html',
	styleUrls: ['./no-internet-connection.component.scss']
})
export class NoInternetConnectionComponent implements OnInit {
	title = 'Connection Lost';
	description = 'No internet connection detected. Please connect your device to' +
		' the internet and try again';
	buttonName = 'Continue';

	constructor(private routeTracker: RouteTrackerService, private router: Router) {
	}

	ngOnInit(): void {

	}

	continue() {
		this.router.navigateByUrl(`${this.routeTracker.getRoutes()?.previousRoute}`);
	}
}
